import { Component, Inject, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SharedService } from "@shared/services/shared.service";
import { IBusinessExemptInspectionsViewModel } from "app/models/mainMenu/mainMenu";
import { BusinessService } from "app/services/business/business.service";

@Component({
  selector: 'annualInspectionModal',
  styleUrls: ['./annualInspectionModal.component.scss'],
  templateUrl: './annualInspectionModal.component.html'
})

export class AnnualInspectionModalComponent implements OnInit {

  businessId: number = 0;
  saved: boolean = false;
  canEdit: boolean = true;
  edit:boolean = true;
  followupInspection: boolean = false;
  siteVisitConducted: boolean = false;
  inspectionType: number = 0;
  followup: number = 0;
  postRem: number = 0;

  ids: boolean = false;

  currentInspection: IBusinessExemptInspectionsViewModel = {} as IBusinessExemptInspectionsViewModel;

  inspection: IBusinessExemptInspectionsViewModel = {
    id: 0,
    complaintId: 0,
    visitDate: '',
    requiredImplementationDate: '',
    requiredVisitDate: '',
    actualCompletionDate: '',
    violationNotes: '',
    correctionRequiredNotes: '',
    remediationResult: '',
    followupDate: '',
    followupConducted: 0,
    followupDateConducted: 0,
    comments: '',
    allowEditing: false,
    businessFollowupSiteVisitId: 0,
    canEdit: true,
    businessName: '',
    businessAddress: '',
    businessCity: '',
    businessZip: '',
    inspectionType: 0,
    visitConductedReason: 0,
    parentInspectionId: 0
  };

  form = new UntypedFormGroup({
    visitDate: new UntypedFormControl(''),
    comments: new UntypedFormControl(''),
    inspectionType: new UntypedFormControl(''),
    followupConducted: new UntypedFormControl(''),
    visitConductedReason: new UntypedFormControl(''),
    remediationResult: new UntypedFormControl(''),

  });

  constructor(
    private sharedService: SharedService,
    private businessService: BusinessService,
    private dialogRef: MatDialogRef<AnnualInspectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data.modalInspection != null && this.data.modalInspection != undefined) {
      this.currentInspection = this.data.modalInspection;
      this.ids = true
      this.setForm(this.currentInspection);
      this.setFlags();
    }
    this.businessId = this.data.businessId;
  }

  ngOnInit(): void {
    this.saved = false;
  }

  save() {
    this.setData();

    this.businessService.saveAnnualInspection(this.businessId, this.inspection).subscribe({
      next: response => {
        this.sharedService.toastr.success("Saved");
        this.saved = true;
        this.return();
      },
      error: e => {
        this.sharedService.toastr.error(e.error);
      },
    });
  }

  return(): void {
    let returnData = this.saved ? 'saved' : 'cancel';
    this.dialogRef.close(returnData);
  }

  setType(type: string){
    this.inspectionType = +type;
  }

  siteVisit(visit: string){
    this.followup = +visit;
  }

  postRemediation(value: number){
    this.postRem = value;
  }

  setForm(data: IBusinessExemptInspectionsViewModel) {
    this.form.patchValue({
      visitDate: new Date(this.currentInspection.visitDate),
      comments: this.currentInspection.comments,
      inspectionType: this.currentInspection.inspectionType != null ? this.currentInspection.inspectionType.toString() : 0,
      followupConducted: this.currentInspection.followupConducted != null? this.currentInspection.followupConducted.toString() : 0,
      visitConductedReason: this.currentInspection.visitConductedReason != null ? this.currentInspection.visitConductedReason.toString():'',
      remediationResult: this.currentInspection.remediationResult
    });
    this.inspectionType = this.currentInspection.inspectionType ;
    this.followup = this.currentInspection.followupConducted != null ? this.currentInspection.followupConducted : 0;
    this.siteVisit(this.followup.toString());
  }

  setData() {
    this.inspection.id = this.currentInspection.id;
    this.inspection.complaintId = this.currentInspection.complaintId;
    this.inspection.visitDate = this.form.controls['visitDate'].value;
    this.inspection.comments = this.form.controls['comments'].value;
    this.inspection.inspectionType = +this.form.controls['inspectionType'].value;
    this.inspection.followupConducted = +this.form.controls['followupConducted'].value;
    this.inspection.visitConductedReason = +this.form.controls['visitConductedReason'].value;
    this.inspection.remediationResult = this.form.controls['remediationResult'].value;
    this.inspection.requiredImplementationDate = this.currentInspection.requiredImplementationDate;
    this.inspection.requiredVisitDate = this.currentInspection.requiredVisitDate;
    this.inspection.actualCompletionDate = this.currentInspection.actualCompletionDate;
    this.inspection.violationNotes = this.currentInspection.violationNotes;
    this.inspection.correctionRequiredNotes = this.currentInspection.correctionRequiredNotes;
    this.inspection.followupDate = this.currentInspection.followupDate;
    this.inspection.followupDateConducted = this.currentInspection.followupDateConducted;
    this.inspection.allowEditing = this.currentInspection.allowEditing;
    this.inspection.businessFollowupSiteVisitId = this.currentInspection.businessFollowupSiteVisitId;
    this.inspection.canEdit = this.currentInspection.canEdit;
    this.inspection.businessName = this.currentInspection.businessName;
    this.inspection.businessAddress = this.currentInspection.businessAddress;
    this.inspection.businessCity = this.currentInspection.businessCity;
    this.inspection.businessZip = this.currentInspection.businessZip;
    this.inspection.parentInspectionId = this.currentInspection.parentInspectionId;

  }

  setFlags(){

  }

}